import { Card, Input, InputNumber, Popover, Button } from "antd";
import { UserOutlined, EnterOutlined, RightOutlined, PushpinOutlined } from '@ant-design/icons';
import { useState } from "react";

interface NewGuessFormProps {
    nameInputRef: any,
    addGuess: any
}

export const NewGuessForm = ({ nameInputRef, addGuess }: NewGuessFormProps) => {

    const [playerName, setPlayerName] = useState<string>();
    const [playerValue, setPlayerValue] = useState<number | undefined>();

    const onOkClick = () => {
        if (playerName !== undefined && playerValue !== undefined) {
            addGuess(playerName, playerValue);
            setPlayerValue(undefined);
        }
    }

    const onNextClick = () => {
        onOkClick();
        setPlayerName(undefined);
        nameInputRef?.current?.focus();
    }

    return (
        <Card title="Neue Schätzung">
            <Input ref={nameInputRef} className="guessInput" size="large" placeholder="Name" prefix={<UserOutlined />} value={playerName} onChange={(e) => setPlayerName(e.target.value)} />
            <br />
            <InputNumber prefix={<PushpinOutlined />} className="guessInput" size="large" placeholder="Schätzung" value={playerValue}
                onChange={(num) => setPlayerValue(num ?? undefined)}
                onPressEnter={onOkClick}
                onKeyDown={(args) => {
                    if (args.key === 'n' || args.key === 'N') {
                        onNextClick();
                        args.preventDefault();
                    }
                }} />

            <Popover placement="right" content={<div className="infoPopup">Drücke <span className="infoPrimary">Enter</span>, um eine weitere Schätzung für diesen Spieler einzugeben.</div>}>
                <Button size="large" className="guessButtonOk" type="dashed" icon={<EnterOutlined />} onClick={onOkClick}>OK</Button>
            </Popover>
            <br />
            <Popover placement="right" content={<div className="infoPopup">Drücke <span className="infoPrimary">N</span>, um mit dem nächsten Spieler fortzufahren.</div>}>
                <Button size="large" className="guessButtonNext" type="primary" icon={<RightOutlined />} onClick={onNextClick}>Nächster</Button>
            </Popover>
        </Card>
        )
}